import { useContext } from 'react'
import { ThemeContext as StyledThemeCopntext } from 'styled-components'
import { ThemeContext } from 'contexts/ThemeContext'

const useTheme = () => {
  const { isDark, toggleTheme } = useContext(ThemeContext)
  const theme = useContext(StyledThemeCopntext)

  const primaryColor = '#31D0AA'
  const dark = '#000'
  const light = '#cdd1d7'

  theme.colors.text = light
  theme.colors.secondary = primaryColor
  theme.colors.textSubtle = primaryColor
  theme.colors.overlay = primaryColor
  theme.colors.primary = primaryColor
  theme.colors.primaryBright = primaryColor
  theme.colors.background = dark
  theme.colors.borderColor = `rgba(0,0,0,0.5)`
  theme.colors.input = `rgba(0,0,0,0.5)`
  theme.colors.overlay = `rgba(0,0,0,0.9)`
  theme.card.background = `rgba(0,0,0,0.2)`
  theme.shadows.focus = primaryColor
  theme.button.subtle.background = primaryColor
  theme.button.primary.background = `#1d4ed8`
  theme.button.primary.color = `#fff`
  theme.button.primary.backgroundActive = `#1e40af`
  theme.button.primary.backgroundHover = `#1e40af`
  theme.button.secondary.border = `2px solid ${primaryColor}`
  theme.button.secondary.borderColorHover = primaryColor
  theme.button.secondary.color = primaryColor
  theme.button.tertiary.color = primaryColor
  theme.button.text.color = primaryColor

  return { isDark, toggleTheme, theme }
}

export default useTheme
